module.exports = __webpack_public_path__ + "img/liucheng.caa7dbe6.png";